import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MainPagetitle from "../../../layouts/MainPagetitle";
import InfoCard from "../MyProfile/InfoCard";

const ConnectorsView = (props) => {
  var BASE_URL = `${endpoints[environment].api_base}/api/v1/files/download/`;
  const isAdmin = props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;
  const [empdata, setEmpdata] = useState({});
  const [accountInfo, setAccountInfo] = useState(null);
  const [docs, setDocs] = useState(null);

  const handleAadharVerify = () => {
    swal2.fire({
      title: "Caution: PAN & Aadhaar Unlinked, TDS at 20%",
      text: "We've noticed your PAN & Aadhaar are unlinked. According to compliance, TDS will be 20%, not 5%.",
      icon: "info",
      iconColor: "#234C9B",
    });
  };

  const getConnectorInfo = () => {
    let connectorId = props?.urlparams?.params?.connectorId;
    props.apis
      .apiGetConnectorDetailsById({ connector_id: connectorId })
      .then((res) => {
        console.log({ apiGetConnectorDetailsById: res });
        setEmpdata(res);
        // ACCOUNT INFO
        if (res?.bank_details) {
          let {
            bank_account_holder_bank_name,
            bank_account_number,
            bank_account_type,
            bank_account_holder_bank_IFSC,
          } = res?.bank_details;
          setAccountInfo({
            bank_account_holder_bank_name,
            bank_account_number,
            bank_account_type,
            bank_account_holder_bank_IFSC,
          });
        }
        // DOCS DETAILS
        if (res?.connector_documents?.length > 0) {
          setDocs({
            ...res?.connector_documents[0],
          });
          let profileUrl = getAvatar(
            res?.connector_documents[0]?.photo_file_id
          );
          console.log({ profileUrl });
          setEmpdata({ ...res, profileUrl });
        }
      });
  };

  const getAvatar = (fileId) => {
    let authToken = props.$store.auth;
    let url = props.apis.apiGetFileThumnail(
      { auth: authToken },
      { fileId: fileId }
    );
    return url;
  };

  const handleDelete = (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    console.log({ value });
    let properties = {
      title: `Are you sure you want to delete this user's ${value?.toTitleCase()} details?`,
      icon: "info",
      iconColor: "#234C9B",
      showCancelButton: true,
      confirmButtonColor: "#234C9B",
      cancelButtonColor: "##D6DBE7",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    };
    let successProperties = {
      title: `${value?.toTitleCase()} details deleted successfully !!`,
      icon: "success",
      iconColor: "#234C9B",
      timer: 4000,
    };
    swal2.fire(properties).then((result) => {
      if (result.isConfirmed) {
        const resolve = () => {
          swal2.fire(successProperties);
          getConnectorInfo();
        };
        if (value === "aadhar") {
          props.apis
            .apiDeleteAadhar({ connector_id: empdata?.connector_id })
            .then(() => resolve());
        }
        if (value === "pan") {
          props.apis
            .apiDeletePan({ connector_id: empdata?.connector_id })
            .then(() => resolve());
        }
      }
    });
  };

  const handleAgreement = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let payload = {
      connector_id: empdata?.connector_id,
    };
    props.apis.apiSendAgreementForEsign(payload).then((res) => {
      console.log({ res });
    });
  };

  useEffect(() => {
    getConnectorInfo();
  }, []);

  props.$setNode({
    props,
  });
  return (
    <>
      <MainPagetitle
        mainTitle="Connectors"
        back={`${empdata?.full_name || "User"}`}
        backLink="/app/connectors"
        pageTitle={"Connectors"}
        parentTitle={"Home"}
      />
      <div className="container-fluid employee_card_container">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <InfoCard hideEdit={false} data={empdata} />

                {/* BOTTOM CARDS */}
                <div className="row">
                  {/* AADHAR */}
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="card profile_card">
                      <div className="card-header border-0">
                        <div className="d-flex align-items-center">
                          <div className="img_outer">
                            <img src={imagepaths.aadharIcon} alt="aadhar" />
                          </div>
                          <h5 className="title ms-2">Aadhar</h5>
                        </div>
                        <div
                          className={Object.className({
                            "action_box d-flex align-items-center": true,
                          })}
                        >
                          {empdata?.connector_aadhar_info?.length > 0 ? (
                            <>
                              <button
                                type="button"
                                onClick={(...args) =>
                                  handleDelete(...args, "aadhar")
                                }
                              >
                                <i class="fa-regular fa-trash-can"></i>
                              </button>
                              <div className="separator"></div>
                              <i className="fa fa-check check_icon"></i>
                            </>
                          ) : (
                            <i class="fa-solid fa-xmark check_icon"></i>
                          )}
                        </div>
                      </div>
                      <div className="card-body">
                        <h5>Aadhar no</h5>
                        <p>{empdata?.connector_aadhar_info?.uid || "-"}</p>
                        <h5>Address</h5>
                        <p>{empdata?.connector_aadhar_info?.address || "-"}</p>
                      </div>
                    </div>
                  </div>

                  {/* PAN */}
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="card profile_card">
                      <div className="card-header border-0">
                        <div className="d-flex align-items-center">
                          <div className="img_outer">
                            <img src={imagepaths.panIcon} alt="pan" />
                          </div>
                          <h5 className="title ms-2">Pan</h5>
                        </div>
                        <div
                          className={Object.className({
                            "action_box d-flex align-items-center": true,
                          })}
                        >
                          {empdata?.connector_pan_info?.length > 0 ? (
                            <>
                              <button
                                type="button"
                                onClick={(...args) =>
                                  handleDelete(...args, "pan")
                                }
                              >
                                <i class="fa-regular fa-trash-can"></i>
                              </button>
                              <div className="separator"></div>
                              <i className="fa fa-check check_icon"></i>
                            </>
                          ) : (
                            <i class="fa-solid fa-xmark check_icon"></i>
                          )}
                        </div>
                      </div>
                      <div className="card-body">
                        <h5>Name as per PAN</h5>
                        <p>{empdata?.connector_pan_info?.name || "-"}</p>
                        <h5>PAN No</h5>
                        <p>{empdata?.connector_pan_info?.number || "-"}</p>
                        <div className="d-flex justify-content-between">
                          <div className="text_content_box">
                            <h5>Aadhar Seeding Successful</h5>
                            <p>
                              {empdata?.connector_pan_info === null
                                ? "-"
                                : empdata?.connector_pan_info
                                    ?.aadhaar_seeding_status === "Successful"
                                ? "Yes"
                                : "No"}
                            </p>
                          </div>
                          {empdata?.connector_pan_info !== null &&
                            empdata?.connector_pan_info
                              ?.aadhaar_seeding_status !== "Successful" && (
                              <button
                                type="button"
                                className="btn info_btn"
                                onClick={(...args) =>
                                  handleAadharVerify(...args)
                                }
                              >
                                <i className="fa fa-info"></i>
                              </button>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ACCOUNT INFO */}
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="card profile_card">
                      <div className="card-header border-0">
                        <div className="d-flex align-items-center">
                          <div className="img_outer">
                            <img src={imagepaths.accountIcon} alt="aadhar" />
                          </div>
                          <h5 className="title ms-2">Account Info</h5>
                        </div>
                        <div className="action_box d-flex align-items-center">
                          {empdata?.connector_documents?.length > 0 ? (
                            <i className="fa fa-check check_icon"></i>
                          ) : (
                            <i className="fa fa-xmark check_icon"></i>
                          )}
                        </div>
                      </div>
                      <div className="card-body">
                        <h5>Account holder name</h5>
                        <p>
                          {accountInfo?.bank_account_holder_bank_name || "-"}
                        </p>
                        <div className="row">
                          <div className="col">
                            <h5>Account No.</h5>
                            <p>{accountInfo?.bank_account_number || "-"}</p>
                          </div>
                          <div className="col">
                            <h5>Account Type</h5>
                            <p>{accountInfo?.bank_account_type || "-"}</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <h5>Bank name</h5>
                            <p>
                              {accountInfo?.bank_account_holder_bank_name ||
                                "-"}
                            </p>
                          </div>
                          <div className="col">
                            <h5>IFSC Code</h5>
                            <p>
                              {accountInfo?.bank_account_holder_bank_IFSC ||
                                "-"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* DOC DETAILS */}
                  <div className="col-12">
                    <div className="card profile_card">
                      <div className="card-header border-0">
                        <div className="d-flex align-items-center mb-3">
                          <img
                            src={imagepaths.cardGaurdIcon}
                            alt="cardGaurdIcon"
                            className="card_icon"
                          />
                          <h5 className="title ms-2 mb-0">Docs Details</h5>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="docs_card_container">
                          <div className="">
                            <div className="docs_card">
                              <img
                                src={imagepaths.pancardIcon}
                                alt="pancardIcon"
                              />
                              <div className="content">
                                <h2 className="title">PAN Card Front</h2>
                                {docs?.pan_file_id ? (
                                  <a href={`${BASE_URL}${docs?.pan_file_id}`}>
                                    Download
                                  </a>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="">
                            <div className="docs_card">
                              <img
                                src={imagepaths.aadharcardIcon}
                                alt="aadharcardIcon"
                              />
                              <div className="content">
                                <h2 className="title">Aadhar Card (Front)</h2>
                                {docs?.aadhar_front_file_id ? (
                                  <a
                                    href={`${BASE_URL}${docs?.aadhar_front_file_id}`}
                                  >
                                    Download
                                  </a>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="">
                            <div className="docs_card">
                              <img
                                src={imagepaths.aadharcardIcon}
                                alt="aadharcardIcon"
                              />
                              <div className="content">
                                <h2 className="title">Aadhar Card (Back)</h2>
                                {docs?.aadhar_back_file_id ? (
                                  <a
                                    href={`${BASE_URL}${docs?.aadhar_back_file_id}`}
                                  >
                                    Download
                                  </a>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="">
                            <div className="docs_card">
                              <img
                                src={imagepaths.agreementcardIcon}
                                alt="agreementcardIcon"
                              />
                              <div className="content">
                                <h2 className="title">Agreement</h2>
                                {docs?.agreement_file_id ? (
                                  <a
                                    href={`${BASE_URL}${docs?.agreement_file_id}`}
                                  >
                                    Download
                                  </a>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="">
                            <div className="docs_card">
                              <img
                                src={imagepaths.chequecardIcon}
                                alt="chequecardIcon"
                              />
                              <div className="content">
                                <h2 className="title">Cheque</h2>
                                {docs?.bank_cheque_file_id ? (
                                  <a
                                    href={`${BASE_URL}${docs?.bank_cheque_file_id}`}
                                  >
                                    Download
                                  </a>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="esign_box mt-4">
                          <div className="d-flex align-items-center">
                            {/* <i
                                  className={Object.className({
                                    "me-2": true,
                                    "fa-regular fa-circle-check text-green":
                                      empdata?.is_agreement_signed === true,
                                    "fa-regular fa-circle-xmark":
                                      empdata?.is_agreement_signed === false,
                                  })}
                                ></i> */}

                            {empdata?.is_agreement_signed === true && (
                              <>
                                <img
                                  src={imagepaths.greenCheckIcon}
                                  alt="icon"
                                />
                                <p className="m-0">E-Signed Done</p>
                              </>
                            )}
                            {empdata?.is_agreement_signed === false && (
                              <>
                                <img src={imagepaths.redCrossIcon} alt="icon" />
                                <p className="m-0">E-Signed Not Done</p>
                              </>
                            )}
                          </div>
                          {empdata?.is_agreement_signed &&
                            empdata?.is_agreement_signed !== true && (
                              <button
                                type="button"
                                className={Object.className({
                                  // "btn btn-primary": true,
                                  "d-none": !isAdmin,
                                })}
                                onClick={(...args) => handleAgreement(...args)}
                              >
                                Re-Initiate
                              </button>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 text-end">
          <Link to={"/app/connectors"} class="btn btn-primary px-4">
            Back
          </Link>
        </div>
      </div>
    </>
  );
};

export default constore(ConnectorsView);
